import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { CircleHelp } from "lucide-react";
import { Button, Tooltip, TooltipTrigger, TooltipContent, } from "../../components/base";
export const TipIconButton = ({ tip, button, icon, ...props }) => {
    return (_jsxs(Tooltip, { children: [_jsx(TooltipTrigger, { asChild: true, children: button ?? (_jsx(Button, { size: "icon", variant: "ghost", ...props, children: icon ?? _jsx(CircleHelp, { className: "h-4 w-4" }) })) }), _jsx(TooltipContent, { children: _jsx("p", { children: tip }) })] }));
};
//# sourceMappingURL=TipIconButton.js.map